import { Product } from '@core/models/piramide/Product';
import { Incompatibilities } from './Incompatibilities';

export class ProductInCompatibility<T> {
  product: T;
  cantidad: number;
  incompatibilities: Incompatibilities[];
  public constructor(product: T, cantidad: number = 0) {
    this.product = product;
    this.cantidad = cantidad;
    this.incompatibilities = [];
  }
}
